module.exports = __webpack_public_path__ + "media/images/icons/self-storage-large-10x20-icon-da8fc042d6720ab90709759c0c466283.png";